import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarRange, ChevronRight } from "lucide-react";
import { useCalendario } from "@/modules/calendario/hooks/useCalendario";
import { AgendaCalendario } from "@/modules/calendario/components/AgendaCalendario";

/**
 * Preview do Calendário na Home (/inicio): a agenda do que vem pela frente
 * (Modelo A aprovado). Universal — todos os membros veem, cada um conforme a
 * RLS dos módulos. Sem nada agendado (ou enquanto carrega), a seção fica
 * oculta, como no preview de Comunicados.
 */
export function PreviewAgendaHome() {
  const navigate = useNavigate();

  const { inicioISO, fimISO } = useMemo(() => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const fim = new Date(hoje);
    fim.setDate(fim.getDate() + 9);
    fim.setHours(23, 59, 59, 999);
    return { inicioISO: hoje.toISOString(), fimISO: fim.toISOString() };
  }, []);

  const { data: itens, isLoading } = useCalendario(inicioISO, fimISO);
  const proximos = (itens ?? []).slice(0, 4);

  if (isLoading || proximos.length === 0) return null;

  return (
    <section className="mb-6 rounded-2xl border border-border bg-surface p-4 sm:p-5">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-bold text-text">
          <CalendarRange size={18} className="text-primary" /> Próximos no calendário
        </h2>
        <button
          onClick={() => navigate("/calendario")}
          className="inline-flex items-center gap-1 text-sm font-bold text-primary hover:underline"
        >
          Ver tudo <ChevronRight size={16} />
        </button>
      </div>
      <AgendaCalendario itens={proximos} vazio="Nada agendado nos próximos dias." />
    </section>
  );
}
